<div *ngIf="casosclinicos.length > 0" class="container-casosclinicos">
    <h2 style="text-align: center;">Casos clínicos</h2>
    <p-table [value]="casosClinicos" [tableStyle]="{ 'min-width': '50rem' }">
        <ng-template pTemplate="header">
            <tr>
                <th>Fecha</th>
                <th>Folio</th>
                <th>Cirugía</th>
                <th>Hospital</th>
                <th>Medico</th>
                <th>Enfermera</th>
                <th>No. Productos</th>
                <th>No. Documentos</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-casoclinico>
            <tr>
                <td>{{casoclinico.fecha | date: 'dd/MM/yyyy'}}</td>
                <td><a [routerLink]="['/supervisor/casoclinico', casoclinico.id]">{{casoclinico.serie}}</a></td>
                <td>{{casoclinico.nomCuerpo}}</td>
                <td>{{casoclinico.nomHospital}}</td>
                <td>{{casoclinico?.medico?.nom_medico | uppercase}}</td>
                <td>{{casoclinico?.enfermera?.nom_enfermera | uppercase}}</td>
                <td>{{casoclinico.productos?.length}}</td>
                <td>{{casoclinico.documentos?.length}}</td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="8" class="text-center p-4">
                    <div class="flex flex-column align-items-center">
                        <i class="pi pi-inbox text-600" style="font-size: 2rem"></i>
                        <span class="text-600 mt-2">No se encontraron casos clínicos</span>
                    </div>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="summary">
            <div class="flex align-items-center justify-content-between">
                No. Registros: {{totalItemsCasosClinicos}}, Total paginas {{totalPaginasCasosClinicos}}
            </div>
        </ng-template>
    </p-table>
    <div class="card flex justify-content-center">
        <p-paginator (onPageChange)="onPageChangeCasosClinicos($event)" [first]="currentPageCasosClinicos.first"
            [rows]="currentPageCasosClinicos.rows" [totalRecords]="totalItemsCasosClinicos"></p-paginator>
    </div>
</div>